/**
 * 작성자 : 박승호
 * 날짜 : 2024.12.23
 * 기능 : 출장현황 상세보기 모달 컴포넌트
 */

import { useEffect, useState } from 'react';
import Portal from '../Portal';
import { ModalBackground } from '../../assets/styles/Modal';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import MapContainer from './MapViewModal';
import { BtnBlue, BtnGray } from '../Button';
import useOnKeydownPgUp from '../../utils/useOnKeydownPgUp';
import useOnKeydownPgDn from '../../utils/useOnKeydownPgDn';
import Input from '../Input';
import MultiSelect from '../MultiSelect';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import useBackHistory from '../../hooks/useBackHistory';

const Root = styled.div`
  position: relative;
  transition: all ease 0.8s;
  width: 100%;
  height: 100vh;
  height: inherit;
  justify-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
  align-items: center;

  .modalHeaderTitle {
    color: var(--text-primary);
  }

  .centered-content {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > .modal {
    z-index: 6000;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 8rem);
    width: 48rem;
    background-color: var(--board);
    border-radius: 0.5rem;
    overflow: hidden;

    .tag {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      font-size: 0.875rem;
      padding: 0 0.75rem;
      color: #fff;
      width: 50px;

      &.complete {
        background-color: var(--filled-violet-deep);
      }

      &.allDay {
        background-color: var(--filled-indigo);
      }

      &.important {
        background-color: var(--filled-red-deep);
      }
    }

    > .inputForm-head {
      position: relative;
      font-weight: 500;
      flex-shrink: 0;
      padding: 0.5rem 0.5rem;
      border-bottom: 1px solid var(--outline);

      .modalHeaderCenter {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: var(--text-primary);
      }

      > svg {
        width: 24px;
        height: 24px;
      }
      .closeBtn {
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5rem;
        cursor: pointer;
        margin: 0 0.5rem;
        color: var(--text-primary);
      }
      .closeBtn:hover {
        background-color: var(--tonal);
      }
      .material-symbols-rounded {
        color: var(--text-primary);
        font-variation-settings: 'FILL' 1, 'wght' 500, 'GRAD' 0, 'opsz' 20;
      }
      .arrow-icon span {
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .icon-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        gap: 0.25rem;
        cursor: pointer;
        border-radius: 5rem;
        padding-right: 1rem;
        padding-left: 0.5rem;
        font-size: 0.875rem;
        background-color: var(--tonal);
        color: var(--text-primary);
      }
      .icon-btn:hover {
        background-color: var(--tonal-deep);
      }
    }

    > .inputForm-body {
      flex-shrink: 1;
      background-color: var(--board);
      color: #121212;
      overflow-y: initial;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      height: 100%;
      overflow-y: auto;
      padding: 1rem;

      .dash {
        color: var(--text-primary);
      }

      .input-view {
        font-size: 0.875rem;
        // color: var(--text-disabled);

        &.date {
          text-align: center;
          max-width: 7rem;
        }

        &.csBox {
          width: 100%;
          height: 2.5rem;
          padding: 0.25rem 0.5rem;
          border-radius: 0.25rem;
          background: var(--tonal);

          & > span {
            width: 100%;
            padding: 0.25rem 0.5rem;
            border-radius: 0.25rem;
          }
        }
      }

      .textarea-view {
        width: 100%;
        min-height: 10rem;
        padding: 0.8rem;
        border-radius: 5px;
        font-size: 0.875rem;
        border: none;
        resize: none;
        color: var(--text-primary);
        background: var(--tonal);
        // color: var(--text-disabled);
      }

      .modal-contents-container {
        background-color: var(--board);
        flex-grow: 1;
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        .subHead {
          padding: 2rem 0;
        }
      }
      .modal-contents {
        background-color: var(--board);
        padding: 1rem;
        flex-grow: 1;
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        .subHead {
          padding: 2rem 0;
        }
      }

      & {
        button.btn {
          height: 2.5rem;
          font-size: 0.75rem;
          flex-shrink: 0;
          padding: 0 0.75rem;
          border-radius: 0.25rem;
        }
        button.btn.gray {
          font-weight: 500;
        }
        label {
          width: 4.5rem;
          font-weight: 500;
          flex-shrink: 0;
          font-size: 0.875rem;
          white-space: break-spaces;
          line-height: 1.4;
        }
        .inputForm-group-1280 {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          @media (min-width: 1280px) {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 2rem;
          }
        }
        .inputForm-group-1536 {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          @media (min-width: 1536px) {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 2rem;
          }
        }
        .inputForm-group-1536.withBtn {
          flex-direction: row;
          gap: 0.5rem;
          button {
            transition: none;
          }
          @media (min-width: 1536px) {
            gap: 2rem;
            button {
              margin-left: 0;
              width: fit-content;
            }
          }
        }
        .inputForm-group-1536.withBtn.inputColumnFour {
          input {
            padding: 0;
          }
        }
        .inputForm-row.labelInInput {
          display: flex;
          gap: 0.5rem;
          flex-grow: 1;
          > div {
            flex-grow: 1;
          }
        }
        .inputForm-row.labelOutInput,
        .inputForm-row.labelInInput > div > div {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 0.5rem;
          input {
            flex-shrink: 1;
            height: 2.5rem;
            font-size: 0.875rem;
            padding: 0 0.5rem;
            &:disabled {
              background-color: var(--tonal);
              color: var(--text-disabled);
            }
          }
          > div.viewOnly {
            height: 2.5rem;
            font-size: 0.875rem;
            color: var(--text-primary);
            background-color: var(--tonal);
            border-radius: 0.25rem;
            padding: 0 0.75rem;
            display: flex;
            align-items: center;
          }
          > div {
            flex-grow: 1;
            > ul {
              height: 2.5rem;
              li {
                display: flex;
                width: 100%;
                max-width: 100%;
                span {
                  flex-grow: 1;
                  width: 4rem;
                }
              }
            }
          }
        }
        .detailInfo-group {
          margin: 1rem 0;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1rem;
          @media (min-width: 1536px) {
            grid-template-columns: repeat(3, 1fr);
          }
          .flex-col.detailInfo {
            flex-grow: 1;
            width: 100%;
            div {
              height: 2.5rem;
              color: var(--text-tertiary);
              background-color: var(--tonal);
              border-radius: 0.25rem;
              display: flex;
              align-items: center;
              padding: 0 0.5rem;
              font-size: 0.875rem;
            }
          }
        }
      }

      .dateForm-group {
        display: grid;
        grid-template-columns: 1fr 1fr 112px;
        gap: 1rem;
      }

      .tab-wrapper {
        display: flex;
        justify-content: flex-start;
        gap: 1rem;
      }

      .address_wrap {
        & > div {
          width: 100%;
        }
      }

      .user_wrap {
        display: flex;
        align-items: stretch;
        gap: 0.5rem;
        height: 100%;

        .button {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 0.25rem;
          padding: 0 0.5rem;
          margin: auto 0;
        }

        .add-button {
          min-width: 3rem;
          height: 48px;
          background-color: var(--filled-slate-deep);
          color: var(--board);
          &:hover {
            outline: 0.25rem solid var(--tonal-deep);
            &:active {
              transform: scale(0.95);
            }
          }
        }
      }

      .contents_wrap {
        & > div {
          width: 100%;
        }
      }

      .checkForm-row {
        display: flex;
        align-items: center;

        label {
          width: auto;
        }
      }

      .loopForm {
        display: grid;
        grid-template-columns: 4.5rem 1fr 2fr;
        grid-column-gap: 0.5rem;
      }

      .timeBox {
        width: 6rem;
      }

      .uploadForm {
        flex-direction: column;
        width: 100%;
        gap: 0.5rem;

        .uploadHead {
          width: 100%;
          justify-content: space-between;
        }
      }

      .file-wrap {
        width: 100%;
        height: 300px;
        overflow-y: auto;
        padding: 0.5rem;
        border-radius: 0.5rem;
        border: 1px solid var(--outline);

        .file-inner {
          display: flex;
          flex-direction: column !important;
          width: 100%;
          gap: 1rem;
        }

        .file-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        }

        .file {
          display: flex;
          align-items: center;
          gap: 0.5rem;

          span {
            font-size: 0.875rem;
            color: var(--text-primary);
          }
        }

        .file-btn {
          width: auto;
          height: 2rem;
          padding: 0 0.5rem;

          span.material-symbols-rounded {
            font-variation-settings: 'FILL' 1, 'wght' 400;
            font-size: 1.25rem;
          }
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: space-between;
      border-top: 1px solid var(--outline);
      padding: 0.5rem;
      > div {
        gap: 0.25rem;
        > button {
          height: 2.5rem;
          font-size: 0.875rem;
          width: 6rem;
          padding: 0;
          @media screen and (max-width: 767px) {
            width: fit-content;
            padding: 0 1.5rem;
          }
        }
      }
      > .arrows {
        button {
          gap: 0.25rem;
          width: fit-content;
          gap: 0.5rem;
          background-color: #e5f1ff;
          background-color: var(--tonal);
          &:hover {
            background-color: var(--tonal-deep);
          }
          &:nth-child(1) {
            padding-left: 0.25rem;
            padding-right: 0.5rem;
            @media screen and (max-width: 767px) {
              padding-right: 1rem;
            }
            > div:nth-child(3) {
              padding-left: 0.5rem;
              border-left: 1px solid var(--outline);
              @media screen and (max-width: 767px) {
                display: none;
              }
              p {
                text-align: left;
              }
            }
          }
          &:nth-child(2) {
            padding-left: 0.5rem;
            padding-right: 0.25rem;
            @media screen and (max-width: 767px) {
              padding-left: 1rem;
            }
            > div:nth-child(1) {
              padding-right: 0.5rem;
              border-right: 1px solid var(--outline);
              @media screen and (max-width: 767px) {
                display: none;
              }
              p {
                text-align: right;
              }
            }
          }
          > p,
          > span {
            color: var(--selected-primary);
          }
          > div {
            p {
              color: var(--text-tertiary);
              font-size: 0.625rem;
              line-height: 1.125;
              letter-spacing: 0.025rem;
              font-weight: 600;
            }
          }
        }
      }
    }
  }

  .users-tag-cont {
    display: flex;
    align-items: center;

    .user-tag {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: var(--filled-slate-deep);
      color: #f1f1f1;
      font-size: 0.875rem;
      border-radius: 0.25rem;
      padding: 0.25rem 0.5rem;
    }
  }
`;

interface Props {
  openModal: any;
  setOpenModal: any;
  apiList: any;
  setRowKey: any;
  listCount: number;
}

const TravelViewModal = ({ openModal, setOpenModal, apiList, setRowKey, listCount }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [openSubModal, setOpenSubModal] = useState({ type: '', status: false });
  const [users, setUsers] = useState(openModal.data.users.map((el: any) => ({ label: el.userName, value: el.userName })));
  const { isPgUpPressed, setIsPgUpPressed } = useOnKeydownPgUp();
  const { isPgDnPressed, setIsPgDnPressed } = useOnKeydownPgDn();

  const onClickClose = () => {
    setOpenModal((prev: any) => ({ ...prev, status: false }));
  };

  const { onBackPrev } = useBackHistory({ isOpen: openModal.status, onPrev: onClickClose, pageName: 'travelView' });

  useEffect(() => {
    if (isPgUpPressed) {
      onClickPrev();
      setIsPgUpPressed(false);
    }
  }, [isPgUpPressed]);

  useEffect(() => {
    if (isPgDnPressed) {
      onClickNext();
      setIsPgDnPressed(false);
    }
  }, [isPgDnPressed]);

  // 이전 출장현황 보기
  const onClickPrev = () => {
    // 필터링 하고 나서 체크 필요
    if (openModal.data) {
      if (openModal.index + 1 > 1) {
        const newIndex = openModal.index - 1;
        setOpenModal((prev: any) => ({ ...prev, data: apiList[newIndex], index: newIndex }));
        setUsers(apiList[newIndex].users.map((el: any) => ({ label: el.userName, value: el.userName })));
        setRowKey(newIndex);
        if (listCount) {
          navigate({
            pathname: location.pathname,
            search: `?pageNum=${Math.floor(newIndex / listCount) - 1}`,
          });
        }
      } else {
        toast.info(t('이전 출장현황이 없습니다'));
      }
    } else {
      toast.warn(t('오류가 발생했습니다'));
    }
  };

  // 다음 출장현황 보기
  const onClickNext = () => {
    if (openModal.data) {
      if (apiList.length !== openModal.index + 1) {
        const newIndex = openModal.index + 1;
        setOpenModal((prev: any) => ({ ...prev, data: apiList[newIndex], index: newIndex }));
        setUsers(apiList[newIndex].users.map((el: any) => ({ label: el.userName, value: el.userName })));
        setRowKey(newIndex);
        if (listCount) {
          navigate({
            pathname: location.pathname,
            search: `?pageNum=${Math.floor(newIndex / listCount) + 1}`,
          });
        }
      } else {
        toast.info(t('다음 출장현황이 없습니다'));
      }
    } else {
      toast.warn(t('오류가 발생했습니다'));
    }
  };

  return (
    <ModalBackground>
      <Root>
        <div
          className='modal'
          role='presentation'
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className='inputForm-head flex-between'>
            <div className='innerTabChip flex-start' style={{ gap: '0.5rem' }}>
              <div className='modalHeaderTitle'>{t('출장현황')}</div>
              {openModal.data.completeYn === 'Y' && <span className='tag complete'>{t('완료')}</span>}
            </div>
            <div className='closeBtn' onClick={onBackPrev} role='presentation'>
              <span className='material-symbols-rounded'>close</span>
            </div>
          </div>

          <div className='inputForm-body inputForm'>
            <div className='withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='date'>{t('날짜')}</label>
                <div className='flex-basic' style={{ gap: '0.5rem' }}>
                  <input type='text' id='sDate' name='sDate' className='input-view date' value={openModal.data.sDate} disabled={!false} />
                  <span className='dash'>~</span>
                  <input type='text' id='fDate' name='fDate' className='input-view date' value={openModal.data.fDate} disabled={!false} />
                  {openModal.data.alldayYn === 'Y' && <span className='tag allDay'>{t('종일')}</span>}
                </div>
              </div>
            </div>

            {openModal.data.alldayYn !== 'Y' && (
              <div className='withBtn'>
                <div className='inputForm-row labelInInput'>
                  <label htmlFor='time'>{t('시간')}</label>
                  <div className='flex-basic' style={{ gap: '0.5rem' }}>
                    <input type='text' id='sTime' name='sTime' className='input-view date' value={openModal.data.sTime} disabled={!false} />
                    <span className='dash'>~</span>
                    <input type='text' id='fTime' name='fTime' className='input-view date' value={openModal.data.fTime} disabled={!false} />
                  </div>
                </div>
              </div>
            )}

            <div className='withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='smName'>{t('일정명')}</label>
                <div className='flex-basic' style={{ gap: '0.5rem' }}>
                  <input type='text' id='smName' name='smName' className='input-view' value={openModal.data.smName} disabled={!false} />
                  {openModal.data.importantYn === 'Y' && <span className='tag important'>{t('중요')}</span>}
                </div>
              </div>
            </div>

            <div className='withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='hsCd'>{t('현장명')}</label>
                <div className='flex-basic' style={{ gap: '0.5rem' }}>
                  <input type='text' id='hsCd' name='hsCd' className='input-view' value={openModal.data.hsCd} disabled={!false} />
                </div>
              </div>
            </div>

            <div className='withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='address'>{t('주소')}</label>
                <div className='flex-basic address_wrap' style={{ gap: '0.5rem' }}>
                  <input type='text' id='address1' name='address1' className='input-view' value={openModal.data.mapData.address1} disabled />
                  {openModal.data.mapData.latitude && openModal.data.mapData.longitude && (
                    <BtnGray className='btn' onClick={() => setOpenSubModal({ status: true, type: 'mapView' })}>
                      {t('지도보기')}
                    </BtnGray>
                  )}
                </div>
              </div>
            </div>

            <div className='withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='csName'>{t('공유항목')}</label>
                <div className='flex-basic' style={{ gap: '0.5rem' }}>
                  <div className='input-view csBox'>
                    <span style={{ backgroundColor: openModal.data.csData.backColor, color: openModal.data.csData.fontColor }}>{openModal.data.csData.name}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className='withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='csName'>{t('참가자')}</label>
                <div className='flex-basic' style={{ gap: '0.5rem' }}>
                  <div className='users-tag-cont'>
                    {users.map((user: any, idx: number) => (
                      <div className='user-tag' key={idx} style={{ display: user.value === '' ? 'none' : 'flex' }}>
                        {user.value}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className='withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='contents'>{t('일정내용')}</label>
                <div className='flex-basic' style={{ gap: '0.5rem' }}>
                  <textarea id='contents' name='contents' className='textarea-view' value={openModal.data.contents} disabled={!false} />
                </div>
              </div>
            </div>

            <div className='withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='carInfo'>{t('차량정보')}</label>
                <div className='flex-basic' style={{ gap: '0.5rem' }}>
                  <input type='text' id='carInfo' name='carInfo' className='input-view' value={openModal.data.carInfo} disabled={!false} />
                </div>
              </div>
            </div>

            <div className='withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='dName'>{t('운전자')}</label>
                <div className='flex-basic' style={{ gap: '0.5rem' }}>
                  <input type='text' id='dName' name='dName' className='input-view' value={openModal.data.dName ?? '-'} disabled={!false} />
                </div>
              </div>
            </div>
          </div>

          <div className='modal-footer flex-between'>
            <div className='flex-basic arrows'>
              <BtnBlue onClick={onClickPrev}>
                <span className='material-symbols-rounded'>arrow_back_ios_new</span>
                <p>{t('이전')}</p>
                <div>
                  <p>Page</p>
                  <p>Up</p>
                </div>
              </BtnBlue>
              <BtnBlue onClick={onClickNext}>
                <div>
                  <p>Page</p>
                  <p>Down</p>
                </div>
                <p>{t('다음')}</p>
                <span className='material-symbols-rounded'>arrow_forward_ios</span>
              </BtnBlue>
            </div>
            <div className='flex-basic'>
              <BtnGray onClick={onClickClose}>{t('닫기')}</BtnGray>
            </div>
          </div>
        </div>
        <Portal openModal={openSubModal.status}>
          {openSubModal.status && openSubModal.type === 'mapView' && <MapContainer openModal={openSubModal} setOpenModal={setOpenSubModal} address={openModal.data.mapData} />}
        </Portal>
      </Root>
    </ModalBackground>
  );
};

export default TravelViewModal;
